import { Suspense } from "react";
import {  Routes, Route, Navigate } from "react-router-dom";
import { routes as mainRoutes } from "./principalroutes";
import LoadingPlanet from "../components/composed-styled-components/LoadingPlanet/LoadingPlanet";

const PrincipalNavigation = () => {
  return (
    <Suspense fallback={<LoadingPlanet subtitle="Loading content..." />}>
      <Routes>
        {mainRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route path="/*" element={<Navigate to={mainRoutes[0].to} replace />} />
      </Routes>
    </Suspense>
  );
};

export default PrincipalNavigation;
